import * as React from 'react';
import { isNullOrUndefined } from 'util';

interface IProps {
    term: string;
    onTermClick: any;
    defaultChecked: boolean;
    showHits: boolean;
    initialCount?: number;
    id: string;
}


export default function SimpleFacetCheckbox(props: IProps) {
    return (
        <div className="paginated-facet">
            <div className="paginated-facet-checkbox-container">

                <input
                    type="checkbox"
                    id={props.id}
                    value={props.term}
                    className="paginated-facet-checkbox"
                    defaultChecked={props.defaultChecked}
                    onChange={props.onTermClick} />


                <label htmlFor={props.term} className="form-element-checkbox-text">
                    <span className="form-element-checkbox-text-term">{props.term}</span>
                    {props.showHits && !isNullOrUndefined(props.initialCount) &&
                        <span className="form-element-checkbox-text-number">
                            <span className="search-facet-item-number">({props.initialCount})</span>
                        </span>
                    }
                </label>

            </div>
        </div>
    )
}
